(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const purchaseOptions = document.querySelector(
        'purchase-options'
      );
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      this.submitButton.classList.add('disabled');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.hasAttribute('data-has-pre-order')) {
        formData.append('properties[Pre-order]', 'Yes');
      }
      if (
        this.cartDrawer &&
        typeof this.cartDrawer.getSectionsToRender === 'function'
      ) {
        formData.append(
          'sections',
          this.cartDrawer
            .getSectionsToRender()
            .map(section => section.section)
        );
      }
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (
            this.cartDrawer &&
            typeof this.cartDrawer.renderContents === 'function'
          ) {
            this.cartDrawer.renderContents(response);
          }
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;

      let message = errorMessage;

      if (typeof errorMessage === 'object' && errorMessage !== null) {
        message = Object.values(errorMessage).flat().join(', ');
      }

      errorWrapper.classList.toggle('hidden', !message);
      errorWrapper.textContent = message || '';
    }

    toggleAddButton(disable, text) {
      const buttons = [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ];

      buttons.forEach(button => {
        if (!button) return;

        if (disable) {
          button.setAttribute('disabled', 'disabled');
          if (text) button.textContent = text;
        } else {
          button.removeAttribute('disabled');
          const isSellingPlan = this.hasAttribute('data-has-selling-plan');
          const isPreOrder = this.hasAttribute('data-has-pre-order');
          const preOrderText =
            (window.variantStrings && window.variantStrings.preOrder) ||
            (window.theme &&
              window.theme.strings &&
              window.theme.strings.preOrder) ||
            (window.variantStrings && window.variantStrings.addToCart);

          button.textContent = isSellingPlan
            ? window.variantStrings.addSubscriptionToCart
            : isPreOrder
              ? preOrderText
              : window.variantStrings.addToCart;
        }
      });
    }
  }

  customElements.define('product-form', ProductForm);
})();
